import { render, staticRenderFns } from "./CreateTicketsFromBookingForm.vue?vue&type=template&id=28ca7138"
import script from "./CreateTicketsFromBookingForm.vue?vue&type=script&lang=js"
export * from "./CreateTicketsFromBookingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports